<app-menu></app-menu>

<section class="controlcli-page" *ngIf="tenantId; else emptyState">
  <header class="page-header">
    <div>
      <p>CRM corporativo</p>
      <h1>ControlCLI</h1>
      <small>Prospecção, propostas e relacionamento em um só lugar.</small>
    </div>
    <div class="tab-row">
      <button type="button" class="tab" [class.active]="selectedTab === 'dashboard'" (click)="switchTab('dashboard')">Dashboard</button>
      <button type="button" class="tab" [class.active]="selectedTab === 'clients'" (click)="switchTab('clients')">Clientes</button>
      <button type="button" class="tab" [class.active]="selectedTab === 'contacts'" (click)="switchTab('contacts')">Contatos</button>
      <button type="button" class="tab" [class.active]="selectedTab === 'prospects'" (click)="switchTab('prospects')">Prospects</button>
      <button type="button" class="tab" [class.active]="selectedTab === 'proposals'" (click)="switchTab('proposals')">Propostas</button>
      <button type="button" class="tab" [class.active]="selectedTab === 'services'" (click)="switchTab('services')">Serviços</button>
      <button type="button" class="tab" [class.active]="selectedTab === 'surveys'" (click)="switchTab('surveys')">Satisfação</button>
    </div>
  </header>

  <section class="tab-content" [ngSwitch]="selectedTab">
    <!-- Dashboard -->
    <div *ngSwitchCase="'dashboard'">
      <div class="cli-dashboard">
        <header class="dashboard-header">
          <div>
            <h2>Dashboard comercial</h2>
            <p>Visualize métricas do CRM e acompanhe o funil de vendas.</p>
          </div>
        </header>

        <div class="hero-cards">
          <article class="hero-card">
            <div class="hero-icon">
              <mat-icon>campaign</mat-icon>
            </div>
            <div class="hero-body">
              <h3>Nova prospecção</h3>
              <p>Registre novos prospects e acompanhe o pipeline.</p>
              <button class="btn outline" type="button" (click)="switchTab('prospects')">Abrir pipeline</button>
            </div>
          </article>
          <article class="hero-card">
            <div class="hero-icon">
              <mat-icon>description</mat-icon>
            </div>
            <div class="hero-body">
              <h3>Gerar proposta</h3>
              <p>Crie propostas e monitore os vencimentos.</p>
              <button class="btn outline" type="button" (click)="switchTab('proposals')">Disparar proposta</button>
            </div>
          </article>
        </div>

        <div class="metric-grid">
          <article class="metric-card accent-teal">
            <div class="metric-icon">
              <mat-icon>groups</mat-icon>
            </div>
            <div>
              <p>Clientes ativos</p>
              <strong>{{ activeClientsCount }}</strong>
              <small>Empresas com contrato vigente.</small>
            </div>
          </article>
          <article class="metric-card accent-blue">
            <div class="metric-icon">
              <mat-icon>timeline</mat-icon>
            </div>
            <div>
              <p>Prospects em negociação</p>
              <strong>{{ pipelineCount('NEGOTIATION') }}</strong>
              <small>Oportunidades em andamento.</small>
            </div>
          </article>
          <article class="metric-card accent-pink">
            <div class="metric-icon">
              <mat-icon>send</mat-icon>
            </div>
            <div>
              <p>Propostas enviadas</p>
              <strong>{{ proposals.length }}</strong>
              <small>Propostas aguardando retorno.</small>
            </div>
          </article>
          <article class="metric-card accent-slate">
            <div class="metric-icon">
              <mat-icon>mood</mat-icon>
            </div>
            <div>
              <p>Média satisfação</p>
              <strong>{{ satisfactionAverage | number:'1.1-1' }}</strong>
              <small>Notas registradas pelos clientes.</small>
            </div>
          </article>
        </div>

        <div class="dashboard-panels">
          <article class="panel">
            <header>
              <div>
                <h3>Pipeline</h3>
                <small>Contagem por estágio</small>
              </div>
            </header>
            <div class="pipeline">
              <div class="pipe-col">
                <p>Novo</p>
                <strong>{{ pipelineCount('NEW') }}</strong>
              </div>
              <div class="pipe-col">
                <p>Contato</p>
                <strong>{{ pipelineCount('CONTACTED') }}</strong>
              </div>
              <div class="pipe-col">
                <p>Proposta</p>
                <strong>{{ pipelineCount('PROPOSAL_SENT') }}</strong>
              </div>
              <div class="pipe-col">
                <p>Negociação</p>
                <strong>{{ pipelineCount('NEGOTIATION') }}</strong>
              </div>
              <div class="pipe-col">
                <p>Assinatura</p>
                <strong>{{ pipelineCount('SIGNATURE') }}</strong>
              </div>
            </div>
          </article>

          <article class="panel">
            <header>
              <div>
                <h3>Próximas propostas a vencer</h3>
                <small>Ordenadas por validade</small>
              </div>
            </header>
            <ul class="proposal-list">
              <li *ngFor="let item of upcomingProposals()">
                <div>
                  <strong>{{ item.proposal_code }}</strong>
                  <p>{{ item.description }}</p>
                </div>
                <div class="meta">
                  <span>{{ formatCurrency(item.value_total) }}</span>
                  <small>Validade: {{ item.valid_until | date:'shortDate' }}</small>
                  <small>Status: {{ translateProposalStatus(item.status) }}</small>
                </div>
              </li>
              <li *ngIf="!proposals.length">
                <p class="empty">Sem propostas no momento.</p>
              </li>
            </ul>
          </article>
        </div>
      </div>
    </div>

    <!-- Clientes -->
    <div *ngSwitchCase="'clients'" class="clients-stack">
      <div class="clients-header-row">
        <h3 class="stack-title">Clientes</h3>
        <button class="btn outline" type="button" (click)="toggleClientForm()">
          {{ showClientForm ? 'Fechar' : 'Cadastrar cliente' }}
        </button>
      </div>

      <article class="panel card-full form-card" *ngIf="showClientForm">
        <header class="panel-header">
          <div>
            <h3>Cadastrar cliente</h3>
            <small>Dados básicos</small>
          </div>
        </header>
        <form [formGroup]="clientForm" (ngSubmit)="submitClient()" class="form-grid">
          <label>CNPJ
            <input
              type="text"
              formControlName="cnpj"
              placeholder="00.000.000/0000-00"
              inputmode="numeric"
              maxlength="18"
              (input)="onCnpjInput($event)">
            <small class="error" *ngIf="(clientFormSubmitted || clientForm.get('cnpj')?.touched) && clientForm.get('cnpj')?.invalid">
              Informe um CNPJ válido.
            </small>
          </label>
          <label>Nome
            <input type="text" formControlName="name" placeholder="Razão social">
            <small class="error" *ngIf="(clientFormSubmitted || clientForm.get('name')?.touched) && clientForm.get('name')?.invalid">
              Informe o nome do cliente.
            </small>
          </label>
          <label>Website
            <input type="text" formControlName="website" placeholder="https://">
          </label>
          <label>Segmento
            <select formControlName="segment">
              <option value="">Selecione</option>
              <option *ngFor="let segment of segmentOptions" [value]="segment">{{ segment }}</option>
            </select>
            <small class="error" *ngIf="(clientFormSubmitted || clientForm.get('segment')?.touched) && clientForm.get('segment')?.invalid">
              Selecione o segmento.
            </small>
          </label>
          <label>Descrição
            <textarea rows="2" formControlName="description" placeholder="Resumo do cliente"></textarea>
          </label>
          <div class="radio-group">
            <span>Status do cliente</span>
            <label class="inline">
              <input type="radio" formControlName="active" value="ACTIVE"> Cliente ativo
            </label>
            <label class="inline">
              <input type="radio" formControlName="active" value="PROSPECT"> Prospect
            </label>
            <small class="error" *ngIf="(clientFormSubmitted || clientForm.get('active')?.touched) && clientForm.get('active')?.invalid">
              Selecione o status do cliente.
            </small>
          </div>
          <button class="btn primary" type="submit">Salvar cliente</button>
        </form>
      </article>

      <article class="panel card-full table-card">
        <header class="actions">
          <div>
            <h3>Clientes</h3>
            <small>{{ clients.length }} registros</small>
          </div>
          <div class="search-box">
            <input type="search" placeholder="Buscar cliente" [(ngModel)]="searchTerm" (ngModelChange)="loadClients()">
          </div>
        </header>
        <table class="data-table fill">
          <thead>
            <tr>
              <th>Nome</th>
              <th>CNPJ</th>
              <th>Segmento</th>
              <th>Site</th>
              <th>Cadastro</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let client of clients" (click)="selectClient(client)" [class.active]="selectedClient?.id === client.id">
              <td>{{ client.name }}</td>
              <td>{{ client.cnpj || '—' }}</td>
              <td>{{ client.segment || '—' }}</td>
              <td>{{ client.website || '—' }}</td>
              <td>{{ client.created_at | date:'dd/MM/yyyy' }}</td>
              <td><span class="pill" [class.success]="client.active"> {{ client.active ? 'Ativo' : 'Prospect' }} </span></td>
            </tr>
            <tr *ngIf="!clients.length">
              <td colspan="6" class="empty">Nenhum cliente cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </article>

      <article class="panel" *ngIf="selectedClient">
        <header class="detail-header">
          <div>
            <h3>Detalhes de {{ selectedClient.name }}</h3>
            <small>CNPJ {{ selectedClient.cnpj }}</small>
          </div>
          <button class="btn outline" type="button" (click)="editingClient ? cancelClientEdit() : startClientEdit()">
            {{ editingClient ? 'Cancelar' : 'Editar' }}
          </button>
        </header>

        <form *ngIf="editingClient; else clientDetailsView" [formGroup]="clientEditForm" (ngSubmit)="saveClientEdit()" class="form-grid">
          <label>CNPJ
            <input
              type="text"
              formControlName="cnpj"
              placeholder="00.000.000/0000-00"
              inputmode="numeric"
              maxlength="18"
              (input)="onCnpjEditInput($event)">
            <small class="error" *ngIf="(clientEditFormSubmitted || clientEditForm.get('cnpj')?.touched) && clientEditForm.get('cnpj')?.invalid">
              Informe um CNPJ válido.
            </small>
          </label>
          <label>Nome
            <input type="text" formControlName="name">
            <small class="error" *ngIf="(clientEditFormSubmitted || clientEditForm.get('name')?.touched) && clientEditForm.get('name')?.invalid">
              Informe o nome do cliente.
            </small>
          </label>
          <label>Website
            <input type="text" formControlName="website">
          </label>
          <label>Segmento
            <select formControlName="segment">
              <option value="">Selecione</option>
              <option *ngFor="let segment of segmentOptions" [value]="segment">{{ segment }}</option>
            </select>
            <small class="error" *ngIf="(clientEditFormSubmitted || clientEditForm.get('segment')?.touched) && clientEditForm.get('segment')?.invalid">
              Selecione o segmento.
            </small>
          </label>
          <label>Descrição
            <textarea rows="2" formControlName="description"></textarea>
          </label>
          <div class="radio-group">
            <span>Status do cliente</span>
            <label class="inline">
              <input type="radio" formControlName="active" value="ACTIVE"> Cliente ativo
            </label>
            <label class="inline">
              <input type="radio" formControlName="active" value="PROSPECT"> Prospect
            </label>
            <small class="error" *ngIf="(clientEditFormSubmitted || clientEditForm.get('active')?.touched) && clientEditForm.get('active')?.invalid">
              Selecione o status do cliente.
            </small>
          </div>
          <div class="btn-row">
            <button class="btn primary" type="submit">Salvar alterações</button>
            <button class="btn ghost" type="button" (click)="cancelClientEdit()">Cancelar</button>
          </div>
        </form>

        <ng-template #clientDetailsView>
          <p>{{ selectedClient.description || 'Sem descrição.' }}</p>
          <div class="quick-meta">
            <span>Segmento: {{ selectedClient.segment || '—' }}</span>
            <span>Site: {{ selectedClient.website || '—' }}</span>
          </div>
        </ng-template>
        <div class="comments-block">
          <h4>Comentários</h4>
          <form [formGroup]="commentForm" (ngSubmit)="editingComment ? saveCommentEdit() : submitComment()" class="form-grid">
            <label>Registrar interação
              <textarea rows="2" formControlName="comment" placeholder="Registrar interação"></textarea>
            </label>
            <div class="btn-row">
              <label class="attach-btn">
                <input type="file" (change)="onCommentFileSelected($event)">
                <mat-icon>attach_file</mat-icon>
                <span>Anexar</span>
              </label>
              <small class="file-name" *ngIf="commentFile">Selecionado: {{ commentFile.name }}</small>
              <button class="btn outline" type="submit">{{ editingComment ? 'Salvar edição' : 'Adicionar comentário' }}</button>
              <button class="btn ghost" type="button" *ngIf="editingComment" (click)="editingComment = null; commentForm.patchValue({ comment: '' });">Cancelar</button>
            </div>
          </form>
          <ul class="comment-list">
            <li *ngFor="let c of clientComments">
              <div class="comment-meta">
                <strong>{{ c.author_name || 'Usuário' }}</strong>
                <small>{{ c.created_at | date:'short' }}</small>
                <button class="link-btn" type="button" (click)="startEditComment(c)">Editar</button>
              </div>
              <p>{{ c.comment }}</p>
              <div class="attachments" *ngIf="c.attachments?.length">
                <small>Anexos:</small>
                <a *ngFor="let att of c.attachments" [href]="formatAttachmentUrl(att.file_path)" target="_blank">{{ att.file_name }}</a>
              </div>
            </li>
            <li *ngIf="!clientComments.length">
              <p class="empty">Nenhum comentário registrado.</p>
            </li>
          </ul>
        </div>
      </article>
    </div>

    <!-- Contatos -->
    <div *ngSwitchCase="'contacts'" class="clients-stack">
      <div class="clients-header-row">
        <h3 class="stack-title">Contatos</h3>
        <button class="btn outline" type="button" (click)="showContactForm = !showContactForm">
          {{ showContactForm ? 'Fechar' : 'Cadastrar contato' }}
        </button>
      </div>
      <article class="panel card-full form-card" *ngIf="showContactForm">
        <header>
          <h3>Novo contato</h3>
          <small>Vincule ao cliente</small>
        </header>
        <form [formGroup]="contactForm" (ngSubmit)="submitContact()" class="form-grid">
          <label>Cliente
            <select formControlName="client_id">
              <option value="">Selecione</option>
              <option *ngFor="let c of clients" [ngValue]="c.id">{{ c.name }}</option>
            </select>
          </label>
          <label>Nome
            <input type="text" formControlName="name">
          </label>
          <label>Área
            <input type="text" formControlName="area">
          </label>
          <label>Cargo
            <input type="text" formControlName="role">
          </label>
          <label>Email
            <input type="email" formControlName="email">
          </label>
          <label>Telefone
            <input type="text" formControlName="phone">
          </label>
          <button class="btn primary" type="submit">Salvar contato</button>
        </form>
      </article>
      <article class="panel card-full table-card">
        <header class="actions">
          <div>
            <h3>Contatos</h3>
            <small>{{ contacts?.length || 0 }} registros</small>
          </div>
          <div class="search-box">
            <input type="search" placeholder="Buscar contato" [(ngModel)]="searchTermContacts">
          </div>
        </header>
        <table class="data-table fill">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Cliente</th>
              <th>Cargo</th>
              <th>Email</th>
              <th>Telefone</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let contact of filteredContacts" (click)="toggleContactDetail(contact)" [class.active]="selectedContact?.id === contact.id && showContactModal">
              <td>{{ contact.name }}</td>
              <td>{{ clientNameById(contact.client_id) }}</td>
              <td>{{ contact.role || '—' }}</td>
              <td>{{ contact.email }}</td>
              <td>{{ contact.phone || '—' }}</td>
            </tr>
            <tr *ngIf="!filteredContacts.length">
              <td colspan="5" class="empty">Nenhum contato cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </article>
      <div class="contact-modal-backdrop" *ngIf="showContactModal" (click)="closeContactModal()"></div>
      <section class="contact-modal" *ngIf="showContactModal" (click)="$event.stopPropagation()">
        <header class="modal-header">
          <div>
            <h3>Contato</h3>
            <small>{{ selectedContact?.name }}</small>
          </div>
          <button class="icon-btn" type="button" (click)="closeContactModal()">✕</button>
        </header>
        <form [formGroup]="contactEditForm" (ngSubmit)="saveContactEdit()" class="form-grid">
          <label>Cliente
            <select formControlName="client_id">
              <option value="">Selecione</option>
              <option *ngFor="let c of clients" [ngValue]="c.id">{{ c.name }}</option>
            </select>
          </label>
          <label>Nome
            <input type="text" formControlName="name">
          </label>
          <label>Área
            <input type="text" formControlName="area">
          </label>
          <label>Cargo
            <input type="text" formControlName="role">
          </label>
          <label>Email
            <input type="email" formControlName="email">
          </label>
          <label>Telefone
            <input type="text" formControlName="phone">
          </label>
          <div class="btn-row">
            <button class="btn outline" type="submit">Salvar alterações</button>
            <button class="btn ghost" type="button" (click)="closeContactModal()">Cancelar</button>
          </div>
        </form>
      </section>
    </div>

    <!-- Prospects -->
    <div *ngSwitchCase="'prospects'" class="clients-stack">
      <div class="clients-header-row">
        <h3 class="stack-title">Prospects</h3>
        <button class="btn outline" type="button" (click)="showProspectForm = !showProspectForm">
          {{ showProspectForm ? 'Fechar' : 'Cadastrar prospect' }}
        </button>
      </div>
      <div class="grid-2">
        <article class="panel card-full form-card" *ngIf="showProspectForm">
          <header>
            <h3>Novo prospect</h3>
            <small>Associe cliente e serviço</small>
          </header>
          <form [formGroup]="prospectForm" (ngSubmit)="submitProspect()" class="form-grid">
            <label>Cliente
              <select formControlName="client_id">
                <option value="">Lead ainda não cliente</option>
                <option *ngFor="let c of clients" [ngValue]="c.id">{{ c.name }}</option>
              </select>
            </label>
            <label>Serviço
              <select formControlName="service_id">
                <option value="">Selecione</option>
                <option *ngFor="let s of services" [ngValue]="s.id">{{ s.name }}</option>
              </select>
            </label>
            <label>Título
              <input type="text" formControlName="prospect_name" placeholder="Ex: Squad antifraude">
            </label>
            <label>Necessidade
              <textarea rows="2" formControlName="need_description"></textarea>
            </label>
            <label>Status
              <select formControlName="status">
                <option value="NEW">Novo</option>
                <option value="CONTACTED">Contato</option>
                <option value="PROPOSAL_SENT">Proposta enviada</option>
                <option value="NEGOTIATION">Negociação</option>
                <option value="SIGNATURE">Assinatura</option>
                <option value="WON">Ganha</option>
                <option value="LOST">Perdida</option>
              </select>
            </label>
            <button class="btn primary" type="submit">Salvar prospect</button>
          </form>
        </article>

        <article class="panel card-full board-card">
          <div class="kanban">
            <div
              class="kanban-col"
              *ngFor="let stage of prospectStages"
              (dragover)="onProspectDragOver($event, stage)"
              (drop)="onProspectDrop($event, stage)"
              [class.drop-target]="dragOverStage === stage">
              <header>
                <small>{{ translateProspectStatus(stage) }}</small>
                <span class="pill">{{ prospectsByStage(stage).length }}</span>
              </header>
              <div class="kanban-cards">
                <article
                  class="kanban-card"
                  *ngFor="let p of prospectsByStage(stage)"
                  draggable="true"
                  (dragstart)="onProspectDragStart($event, p)"
                  (dragend)="onProspectDragEnd()"
                  (click)="selectProspect(p)"
                  [class.is-dragging]="draggingProspect?.id === p.id">
                  <strong>{{ p.prospect_name }}</strong>
                  <small class="client-line">{{ p.client_name || 'Lead' }}</small>
                  <small class="service-line">{{ p.service_name || 'Serviço' }}</small>
                </article>
                <p class="empty" *ngIf="!prospectsByStage(stage).length">Nenhum item</p>
              </div>
            </div>
          </div>
        </article>
      </div>

      <div class="prospect-drawer" *ngIf="showProspectDetail && selectedProspect">
        <div class="drawer-header">
          <div>
            <p>Prospect</p>
            <h3>{{ selectedProspect.prospect_name }}</h3>
            <small>{{ translateProspectStatus(selectedProspect.status) }} · {{ selectedProspect.client_name || 'Lead' }}</small>
          </div>
          <button class="icon-btn" type="button" (click)="closeProspectDetail()">✕</button>
        </div>
        <div class="drawer-section">
          <div class="drawer-toggle" (click)="showProspectEdit = !showProspectEdit">
            <h4>Detalhes</h4>
            <span class="toggle-icon">{{ showProspectEdit ? '–' : '+' }}</span>
          </div>
          <div *ngIf="!showProspectEdit">
            <p>{{ selectedProspect.need_description || 'Sem descrição' }}</p>
            <div class="quick-meta">
              <span>Serviço: {{ selectedProspect.service_name || selectedProspect.service_id }}</span>
              <span>Status: {{ translateProspectStatus(selectedProspect.status) }}</span>
            </div>
          </div>
          <div *ngIf="showProspectEdit">
            <form [formGroup]="prospectDetailForm" (ngSubmit)="saveProspectDetails()" class="form-grid">
              <label>Descrição
                <textarea rows="3" formControlName="need_description"></textarea>
              </label>
              <label>Serviço
                <select formControlName="service_id">
                  <option *ngFor="let s of services" [ngValue]="s.id">{{ s.name }}</option>
                </select>
              </label>
              <label>Etapa
                <select formControlName="status">
                  <option *ngFor="let stage of prospectStages" [ngValue]="stage">{{ translateProspectStatus(stage) }}</option>
                </select>
              </label>
              <div class="btn-row">
                <button class="btn outline" type="submit">Salvar alterações</button>
                <button class="btn ghost" type="button" (click)="showProspectEdit = false">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
        <div class="drawer-section">
          <div class="drawer-toggle" (click)="showProspectContactForm = !showProspectContactForm">
            <h4>Adicionar contato</h4>
            <span class="toggle-icon">{{ showProspectContactForm ? '–' : '+' }}</span>
          </div>
          <div *ngIf="showProspectContactForm">
            <form [formGroup]="prospectContactForm" (ngSubmit)="submitProspectContact()" class="form-grid">
              <label>Nome
                <input type="text" formControlName="name">
              </label>
              <label>Área
                <input type="text" formControlName="area">
              </label>
              <label>Cargo
                <input type="text" formControlName="role">
              </label>
              <label>Email
                <input type="email" formControlName="email">
              </label>
              <label>Telefone
                <input type="text" formControlName="phone">
              </label>
              <div class="btn-row">
                <button class="btn outline" type="submit" [disabled]="!selectedProspect?.client_id">Salvar contato</button>
                <span class="error" *ngIf="!selectedProspect?.client_id">Prospect sem cliente vinculado.</span>
              </div>
            </form>
          </div>
        </div>
        <div class="drawer-section">
          <div class="drawer-toggle" (click)="toggleProposalForm()">
            <h4>Registrar proposta</h4>
            <span class="toggle-icon">{{ showProposalForm ? '–' : '+' }}</span>
          </div>
          <div *ngIf="showProposalForm">
            <form [formGroup]="proposalForm" (ngSubmit)="submitProposal()" class="form-grid">
              <label>Código da proposta
                <input type="text" formControlName="proposal_code" placeholder="25/0001">
              </label>
              <label>Versão da proposta
                <input type="number" formControlName="proposal_version" min="1">
              </label>
              <label>Descrição
                <textarea rows="2" formControlName="description"></textarea>
              </label>
              <label>Valor total do contrato
                <input type="text" formControlName="value_total" inputmode="decimal" (input)="onProposalValueInput($event, 'value_total')">
              </label>
              <label>Valor mensal
                <input type="text" formControlName="value_monthly" inputmode="decimal" (input)="onProposalValueInput($event, 'value_monthly')">
              </label>
              <label>Valor anual
                <input type="text" formControlName="value_annual" inputmode="decimal" (input)="onProposalValueInput($event, 'value_annual')">
              </label>
              <label>Validade
                <input type="date" formControlName="valid_until">
              </label>
              <label class="file-row">
                <input type="file" (change)="onProposalFileSelected($event)">
                <span>Anexar proposta (opcional)</span>
                <small *ngIf="proposalFile">Selecionado: {{ proposalFile.name }}</small>
              </label>
              <button class="btn outline" type="submit">Registrar proposta</button>
            </form>
          </div>
        </div>
        <div class="drawer-section">
          <div class="drawer-toggle" (click)="showCommentForm = !showCommentForm">
            <h4>Comentários</h4>
            <span class="toggle-icon">{{ showCommentForm ? '–' : '+' }}</span>
          </div>
          <div *ngIf="showCommentForm">
            <form [formGroup]="commentForm" (ngSubmit)="editingComment ? saveCommentEdit() : submitComment()" class="form-grid">
              <label>Registrar interação
                <textarea rows="2" formControlName="comment" placeholder="Registrar interação"></textarea>
              </label>
              <label class="file-row">
                <input type="file" (change)="onCommentFileSelected($event)">
                <span>Anexar arquivo (opcional)</span>
                <small *ngIf="commentFile">Selecionado: {{ commentFile.name }}</small>
              </label>
              <div class="btn-row">
                <button class="btn outline" type="submit">{{ editingComment ? 'Salvar edição' : 'Adicionar comentário' }}</button>
                <button class="btn ghost" type="button" *ngIf="editingComment" (click)="editingComment = null; commentForm.patchValue({ comment: '' });">Cancelar</button>
              </div>
            </form>
          </div>
        </div>
        <div class="drawer-section">
          <div class="drawer-toggle" (click)="showHistory = !showHistory">
            <h4>Histórico</h4>
            <span class="toggle-icon">{{ showHistory ? '–' : '+' }}</span>
          </div>
          <div *ngIf="showHistory">
            <div class="search-box compact">
              <input type="search" placeholder="Buscar no histórico" [(ngModel)]="historySearchTerm">
            </div>
            <ul class="timeline">
              <li *ngFor="let item of prospectHistory">
                <div class="timeline-meta">
                  <span class="badge">{{ item.type === 'PROPOSAL' ? 'Proposta' : 'Comentário' }}</span>
                  <small>{{ item.date | date:'short' }}</small>
                </div>
                <p>{{ item.text }}</p>
                <small *ngIf="item.type === 'PROPOSAL' && (item.proposalCode || item.proposalVersion)">
                  Código: {{ item.proposalCode || '—' }} · Versão: {{ item.proposalVersion || '—' }}
                </small>
                <small *ngIf="item.status">Status: {{ translateProposalStatus(item.status) }}</small>
                <div class="attachments" *ngIf="item.attachments?.length">
                  <small>Anexos:</small>
                  <a *ngFor="let att of item.attachments" [href]="formatAttachmentUrl(att.file_path)" target="_blank">{{ att.file_name }}</a>
                </div>
              </li>
              <li *ngIf="!prospectHistory.length">
                <p class="empty">Sem histórico.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Propostas -->
    <div *ngSwitchCase="'proposals'">
      <article class="panel">
        <header>
          <h3>Propostas</h3>
          <small>{{ proposals.length }} itens</small>
        </header>
        <table class="data-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Prospect</th>
              <th>Valor</th>
              <th>Validade</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pr of proposals">
              <td>{{ pr.proposal_code }}</td>
              <td>{{ pr.prospect_name || pr.prospect_id }}</td>
              <td>{{ formatCurrency(pr.value_total) }}</td>
              <td>{{ pr.valid_until | date:'shortDate' }}</td>
              <td><span class="pill">{{ translateProposalStatus(pr.status) }}</span></td>
            </tr>
            <tr *ngIf="!proposals.length">
              <td colspan="5" class="empty">Nenhuma proposta cadastrada.</td>
            </tr>
          </tbody>
        </table>
      </article>
    </div>

    <!-- Serviços -->
    <div *ngSwitchCase="'services'" class="clients-stack">
      <div class="clients-header-row">
        <h3 class="stack-title">Serviços</h3>
        <button class="btn outline" type="button" (click)="showServiceForm = !showServiceForm">
          {{ showServiceForm ? 'Fechar' : 'Cadastrar serviço' }}
        </button>
      </div>
      <article class="panel card-full form-card" *ngIf="showServiceForm">
        <header>
          <h3>Novo serviço</h3>
          <small>Catálogo</small>
        </header>
        <form [formGroup]="serviceForm" (ngSubmit)="submitService()" class="form-grid">
          <label>Nome
            <input type="text" formControlName="name">
            <small class="error" *ngIf="(serviceFormSubmitted || serviceForm.get('name')?.touched) && serviceForm.get('name')?.invalid">
              Informe o nome do serviço.
            </small>
          </label>
          <label>Descrição
            <textarea rows="2" formControlName="description"></textarea>
          </label>
          <label>Apresentação
            <div
              class="dropzone"
              (dragover)="onServiceDragOver($event)"
              (drop)="onServiceFileDropped($event)">
              <input type="file" (change)="onServiceFileSelected($event)" accept=".pdf,.ppt,.pptx">
              <div class="dropzone-content">
                <mat-icon>upload_file</mat-icon>
                <div>
                  <strong>Arraste e solte aqui</strong>
                  <span>ou clique para selecionar</span>
                </div>
              </div>
            </div>
            <small class="file-name" *ngIf="servicePresentationFile">
              Selecionado: {{ servicePresentationFile.name }}
            </small>
          </label>
          <label>Link do produto
            <input type="text" formControlName="product_link" placeholder="https://">
          </label>
          <label>Tipo
            <select formControlName="service_type">
              <option value="SERVICE">Serviço</option>
              <option value="PRODUCT">Produto</option>
              <option value="SUBSCRIPTION">Assinatura</option>
              <option value="PROJECT">Projeto</option>
            </select>
            <small class="error" *ngIf="(serviceFormSubmitted || serviceForm.get('service_type')?.touched) && serviceForm.get('service_type')?.invalid">
              Selecione o tipo.
            </small>
          </label>
          <label class="inline">
            <input type="checkbox" formControlName="active"> Ativo
          </label>
          <button class="btn primary" type="submit">Salvar serviço</button>
        </form>
      </article>

      <article class="panel card-full table-card">
        <header class="actions">
          <div>
            <h3>Catálogo</h3>
            <small>{{ filteredServices.length }} itens</small>
          </div>
          <div class="search-box">
            <input type="search" placeholder="Buscar serviço" [(ngModel)]="searchTermServices">
          </div>
        </header>
        <table class="data-table fill">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of filteredServices" (click)="selectService(s)" [class.active]="selectedService?.id === s.id">
              <td>{{ s.name }}</td>
              <td>{{ s.service_type }}</td>
              <td><span class="pill" [class.success]="s.active">{{ s.active ? 'Ativo' : 'Inativo' }}</span></td>
            </tr>
            <tr *ngIf="!filteredServices.length">
              <td colspan="3" class="empty">Nenhum serviço cadastrado.</td>
            </tr>
          </tbody>
        </table>
      </article>

      <article class="panel" *ngIf="selectedService">
        <header class="detail-header">
          <div>
            <h3>Detalhes do serviço</h3>
            <small>{{ selectedService.name }}</small>
          </div>
          <button class="btn outline" type="button" (click)="editingService ? cancelServiceEdit() : startServiceEdit()">
            {{ editingService ? 'Cancelar' : 'Editar' }}
          </button>
        </header>

        <form *ngIf="editingService; else serviceDetailsView" [formGroup]="serviceEditForm" (ngSubmit)="saveServiceEdit()" class="form-grid">
          <label>Nome
            <input type="text" formControlName="name">
            <small class="error" *ngIf="(serviceEditFormSubmitted || serviceEditForm.get('name')?.touched) && serviceEditForm.get('name')?.invalid">
              Informe o nome do serviço.
            </small>
          </label>
          <label>Descrição
            <textarea rows="2" formControlName="description"></textarea>
          </label>
          <label>Apresentação
            <div
              class="dropzone"
              (dragover)="onServiceEditDragOver($event)"
              (drop)="onServiceEditFileDropped($event)">
              <input type="file" (change)="onServiceEditFileSelected($event)" accept=".pdf,.ppt,.pptx">
              <div class="dropzone-content">
                <mat-icon>upload_file</mat-icon>
                <div>
                  <strong>Arraste e solte aqui</strong>
                  <span>ou clique para selecionar</span>
                </div>
              </div>
            </div>
            <small class="file-name" *ngIf="serviceEditPresentationFile">
              Selecionado: {{ serviceEditPresentationFile.name }}
            </small>
          </label>
          <label>Link do produto
            <input type="text" formControlName="product_link" placeholder="https://">
          </label>
          <label>Tipo
            <select formControlName="service_type">
              <option value="SERVICE">Serviço</option>
              <option value="PRODUCT">Produto</option>
              <option value="SUBSCRIPTION">Assinatura</option>
              <option value="PROJECT">Projeto</option>
            </select>
            <small class="error" *ngIf="(serviceEditFormSubmitted || serviceEditForm.get('service_type')?.touched) && serviceEditForm.get('service_type')?.invalid">
              Selecione o tipo.
            </small>
          </label>
          <label class="inline">
            <input type="checkbox" formControlName="active"> Ativo
          </label>
          <div class="btn-row">
            <button class="btn primary" type="submit">Salvar alterações</button>
            <button class="btn ghost" type="button" (click)="cancelServiceEdit()">Cancelar</button>
          </div>
        </form>

        <ng-template #serviceDetailsView>
          <p>{{ selectedService.description || 'Sem descrição.' }}</p>
          <div class="quick-meta">
            <span>Tipo: {{ selectedService.service_type }}</span>
            <span>Status: {{ selectedService.active ? 'Ativo' : 'Inativo' }}</span>
          </div>
          <div class="quick-meta">
            <span>Link: {{ selectedService.product_link || '—' }}</span>
          </div>
        </ng-template>
      </article>
    </div>

    <!-- Pesquisas -->
    <div *ngSwitchCase="'surveys'" class="grid-2">
      <div>
        <article class="panel">
          <header>
            <h3>Nova pesquisa</h3>
            <small>Coleta de satisfação</small>
          </header>
          <form [formGroup]="surveyForm" (ngSubmit)="submitSurvey()" class="form-grid">
            <label>Título
              <input type="text" formControlName="title">
            </label>
            <label>Descrição
              <textarea rows="2" formControlName="description"></textarea>
            </label>
            <label class="inline">
              <input type="checkbox" formControlName="active"> Ativa
            </label>
            <button class="btn primary" type="submit">Salvar pesquisa</button>
          </form>
        </article>
      </div>

      <div>
        <article class="panel">
          <header>
            <h3>Pesquisas</h3>
            <small>{{ surveys.length }} ativas/inativas</small>
          </header>
          <ul class="proposal-list">
            <li *ngFor="let s of surveys">
              <div>
                <strong>{{ s.title }}</strong>
                <p>{{ s.description || 'Sem descrição' }}</p>
              </div>
              <div class="meta">
                <span class="pill" [class.success]="s.active">{{ s.active ? 'Ativa' : 'Inativa' }}</span>
                <small>Criada em {{ s.created_at | date:'shortDate' }}</small>
              </div>
            </li>
            <li *ngIf="!surveys.length">
              <p class="empty">Nenhuma pesquisa cadastrada.</p>
            </li>
          </ul>
        </article>

        <article class="panel">
          <header>
            <h3>Respostas recentes</h3>
            <small>{{ surveyResponses.length }} respostas</small>
          </header>
          <table class="data-table">
            <thead>
              <tr>
                <th>Pesquisa</th>
                <th>Cliente</th>
                <th>Nota</th>
                <th>Comentário</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of surveyResponses">
                <td>{{ r.survey_title || r.survey_id }}</td>
                <td>{{ r.client_name || r.client_id }}</td>
                <td>{{ r.score }}</td>
                <td>{{ r.feedback || '—' }}</td>
              </tr>
              <tr *ngIf="!hasSurveyResponses">
                <td colspan="4" class="empty">Nenhuma resposta coletada.</td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
    </div>
  </section>
</section>

<ng-template #emptyState>
  <section class="empty-state-full">
    <p>Faça login para acessar o ControlCLI.</p>
  </section>
</ng-template>
